module.exports = __webpack_public_path__ + "static/media/Forma 1.0dbd3314.svg";